import { useQuery } from '@tanstack/react-query';
import type { ChannelRateLimitsResponse } from '@troia-v3/types';
import { channelsApi } from '../services';

/**
 * Lazy fetch dos limites de envio do canal. SEMPRE passar `enabled` baseado
 * no `isOpen` do modal/card pra evitar fetch quando o componente não está
 * visível (regra CLAUDE.md NUNCA #14 — Cross-Module Permissions).
 */
export const useChannelRateLimits = (channelId: string | undefined, enabled: boolean) => {
  return useQuery<ChannelRateLimitsResponse>({
    queryKey: ['channels', channelId, 'rate-limits'],
    queryFn: () => channelsApi.getRateLimits(channelId as string),
    enabled: enabled && Boolean(channelId),
  });
};
